import { IconButton } from "@similarweb/ui-components";

import { SIGNALS_GUIDE_URL } from "app/pages/sales-intelligence/pages/manage-signals/constants";
import manageSignalsPageTrackingService from "app/pages/sales-intelligence/pages/manage-signals/services/tracking";

export const AccountSignalsGuideLink = () => {
    const handleGuideClick = (): void => {
        manageSignalsPageTrackingService.trackOpenGuideLink("accountSignals");
        window.open(SIGNALS_GUIDE_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <IconButton
            iconName="helpcenter"
            type="flat"
            dataAutomation="signals-management-guide-link"
            onClick={handleGuideClick}
        />
    );
};
